<template>
    <div class="flex flex-col items-center">
        <p class="text-200 mt-4 mb-3">
            {{ $t('§caf.contract_saved_modal-contract_id:') }} {{ contractId }}
        </p>

        <CoreLinkPrimary
            class="mb-6"
            text="§ui_button.download_pdf"
            iconName="arrow-right"
            :linkColorBlue="true"
            @click="downloadPdf"
        />

        <div class="flex justify-center gap-2">
            <CoreButton
                label="§ui_button.continue_to_contract_overview"
                icon="pi-arrow-right"
                @click="goToContractView"
            />
            <CoreButton label="§ui_button.back_to_caf" variant="tertiary" @click="goToCaf" />
        </div>
    </div>
</template>

<script>
import { useModalStore } from '@/stores/modal'
import { useCafStore } from '@/stores/caf'
import CoreLinkPrimary from '@/components/core/CoreLinkPrimary.vue'
import CoreButton from '@/components/core/CoreButton.vue'

export default {
    name: 'ContractSavedModal',

    components: {
        CoreLinkPrimary,
        CoreButton,
    },

    data() {
        return {
            modalStore: useModalStore(),
            cafStore: useCafStore(),
            contractId: null,
        }
    },

    mounted() {
        this.contractId = this.modalStore.data.contractId
    },

    methods: {
        downloadPdf() {
            if (!this.cafStore.downloading) {
                this.cafStore.downloadCalculation()
            }
        },

        goToCaf() {
            this.$router.push({
                name: 'ClickAndFinanceForm',
            })
            this.modalStore.setClose()
        },

        goToContractView() {
            this.$router.push({
                name: 'ContractShow',
                params: { id: this.contractId },
            })
            this.modalStore.setClose()
        },
    },
}
</script>
